import { render, staticRenderFns } from "./LapidusAccounts.vue?vue&type=template&id=0fa954f2&"
import script from "./LapidusAccounts.vue?vue&type=script&lang=js&"
export * from "./LapidusAccounts.vue?vue&type=script&lang=js&"
import style0 from "./LapidusAccounts.vue?vue&type=style&index=0&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports